export type Theme = "dark" | "light";

export const THEMES: readonly Theme[] = ["dark", "light"];

export const DEFAULT_THEME: Theme = "light";

export const THEME_STORAGE_KEY = "nablow-theme";

const isTheme = (value: unknown): value is Theme => value === "dark" || value === "light";

export const readStoredTheme = (): Theme => {
  try {
    const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
    return isTheme(stored) ? stored : DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
};

export const applyTheme = (theme: Theme): void => {
  document.documentElement.dataset.theme = theme;
};

export const persistTheme = (theme: Theme): void => {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    return;
  }
};
